import QuestionValue from "./QuestionValue";

export default class QuestionValueGraphLabel extends QuestionValue {
    constructor(value, label = "") {
        super(value);
        this._label = label;
    }

    toString() {
        return this._label;
    }

    set label(value) {
        this._label = value;
    }

    get label() {
        return this._label;
    }
}